export const STORAGE_ITEM_NAME = "tcc_authorize_loggedIn";
export const SECRET_KEY = "chichetaram07";